import React, { useCallback, useState, useMemo } from "react";
import { Modal, Button, Icon, Checkbox, InputNumber, Spin } from "@tinper/next-ui";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import "./index.less";
import i18n from "../i18n";

const deleteIcon = <svg className="icon-delete" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M880 224H144a48 48 0 0 1 0-96H384a64 64 0 0 1 64-64h128a64 64 0 0 1 64 64h240a48 48 0 0 1 0 96zM832 832a128 128 0 0 1-128 128H320a128 128 0 0 1-128-128V288h640V832zM448 464a48 48 0 0 0-96 0v288a48 48 0 0 0 96 0v-288z m224 0a48 48 0 0 0-96 0v288a48 48 0 0 0 96 0v-288z"></path></svg>;
// const { getLangInfo } = Locale;
const LocalModal = (props: any) => {
  const { showModal, handleLocalModal, fileList, fileListChange, editor, locale, modalType, videoPosters, loading } = props;

  const [removedKey, setRemovedKey] = useState([]);
  const [showSet, setShowSet] = useState(false);
  const [imgConfig, setImgConfig] = useState<any>({
    cranny: false, // 无缝隙
    defaultSize: false, // 默认尺寸
    width: null,
    height: null,
    singleLine: false // 单独图片独占一行
  });

  // const [lock, setLock] = useState(true);

  // const handleLock = useCallback(() => {
  //   if (imgConfig.width && imgConfig.height) {
  //     setImgConfig({
  //       ...imgConfig,
  //       height: null
  //     });
  //   }
  //   setLock(!lock);
  // }, [lock, imgConfig]);

  const onClose = useCallback(() => {
    handleLocalModal && handleLocalModal(false);
  }, [fileList, imgConfig]);
  const onSubmit = useCallback(() => {
    if (fileList && fileList.length) {
      const imgList: any = [];
      fileList.forEach((value: any) => {
        if (modalType === 'media') {
          // let html = `<video controls="controls" width="300" height="150"><source src="${value}" type="video/mp4"></video>`
          const html = `<video controls="controls" width="300" height="" src="${value}"></video>`
          editor.insertContent(html);
          return
        }

        // eslint-disable-next-line no-undef
        const image = new Image();
        image.src = value;
        image.onload = () => {
          imgList.push({
            url: value,
            width: image.width,
            height: image.height
          });
          if (imgList.length === fileList.length) {
            let html = "";
            if (imgConfig.defaultSize) {
              if (imgConfig.width && imgConfig.height) { // 未锁定
                imgList.forEach((item: any) => {
                  item.width = parseInt(imgConfig.width);
                  item.height = parseInt(imgConfig.height);
                });
              } else { // 锁定
                if (imgConfig.width) {
                  imgList.forEach((item: any) => {
                    item.height = (parseInt(imgConfig.width) / item.width) * item.height;
                    item.width = parseInt(imgConfig.width);
                  });
                } else {
                  imgList.forEach((item: any) => {
                    item.width = (parseInt(imgConfig.height) / item.height) * item.width;
                    item.height = parseInt(imgConfig.height);
                  });
                }
              }
            }
            if (imgConfig.singleLine) { // 单独占一行
              if (imgConfig.cranny) { // 无缝隙
                // html = `${imgList.map((item: any) => `span<img src="${item.url}" width="${item.width}" style="display: block;"/>`).join("")}`;
                html = `${imgList.map((item: any) => `<span class="as_img_item"><img src="${item.url}" width="${item.width}" style="display: block;"/></span>`).join("")}`;
              } else {
                html = `
            ${imgList.map((item: any) => `
                <span class="as_img_item"><img src="${item.url}" width="${item.width}" style="display: block; margin-bottom: 5px;" /></span>
              `).join("")}
          `;
              }
            } else {
              if (imgConfig.cranny) { // 无缝隙
                html = `${imgList.map((item: any) => `<span class="as_img_item"><img src="${item.url}" width="${item.width}" /></span>`).join("")}`;
              } else {
                html = `${imgList.map((item: any) => `<span class="as_img_item"><img src="${item.url}" width="${item.width}" style="margin-bottom: 5px; margin-right: 5px;" /></span>`).join("")}`;
              }
            }
            editor.insertContent(html);
          }
        }
      });
    }

    handleLocalModal && handleLocalModal(false);
  }, [fileList, imgConfig, editor, modalType]);

  const changeSize = useCallback((value: any, type: string) => {
    if (type === "width") {
      if (value) {
        setImgConfig({ ...imgConfig, width: value, height: null });
      } else {
        setImgConfig({ ...imgConfig, width: value });
      }
    } else if (type === "height") {
      if (value) {
        setImgConfig({ ...imgConfig, height: value, width: null });
      } else {
        setImgConfig({ ...imgConfig, height: value });
      }
    }
  }, [imgConfig]);

  const onDragEnd = useCallback((result: any) => {
    if (!result.destination) {
      return;
    }
    if (result.destination.index === result.source.index) {
      return;
    }
    const _fileList = Array.from(fileList);
    const [removed] = _fileList.splice(result.source.index, 1);
    _fileList.splice(result.destination.index, 0, removed);
    fileListChange && fileListChange(_fileList);
  }, [fileList])

  const localeTaget = useMemo(() => {
    // 先使用本地作为翻译
    // return getLangInfo(locale, i18n)
    const target = {}
    // @ts-ignore
    target.langMap = i18n[locale || 'zh-cn'] || {};
    return target;
  }, [locale])

  const hashCode = (s: string) => {
    return s.split('').reduce(function (a: number, b: string) { a = ((a << 5) - a) + b.charCodeAt(0); return a & a }, 0);
  }

  return (
    <Modal
      autoFocus=".coustomFocus"
      size="xlg"
      visible={showModal}
      destroyOnClose={false}
      // resizable={true}
      resizeClassName="resize-box"
      // draggable
      // maxWidth={"1000"}
      // maxHeight={"500px"}
      minWidth={420}
      minHeight={240}
      onCancel={onClose}
      wrapClassName={'local-modal-pro'}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {modalType === 'media'
            ? localeTaget.langMap.uploadVideosLocally || '本地上传视频'
            : localeTaget.langMap.uploadImagesLocally || '本地上传图片'
          }
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Spin
          locale={locale}
          spinning={modalType === 'media' && loading}
          getPopupContainer={() => document.querySelector('.local-modal-pro .wui-modal-body')}
        />
        <div style={{ position: 'relative' }}>
          {fileList && fileList.length
            // eslint-disable-next-line multiline-ternary
            ? (
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable" direction="horizontal">
                  {(provided: any) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {
                        fileList.map((item: any, index: number) => {
                          const itemKey = hashCode(item) + '_' + index;
                          if (removedKey.includes(item)) {
                            return null
                          }
                          return (
                            <Draggable key={itemKey} draggableId={itemKey} index={index} className={'img_box'}>
                              {(provided: any, snapshot: any) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  key={index}
                                  className={'img_box_item'}
                                  style={{
                                    // backgroundColor: snapshot.isDragging ? '#263B4A' : '#456C86',
                                    ...provided.draggableProps.style
                                  }}
                                >
                                  {
                                    modalType === 'media'
                                      ? <video poster={videoPosters[item]} style={{ width: '100px', height: '60px', pointerEvents: 'none' }} />
                                      : <img src={item} style={{ width: '100px', height: '100px' }} />
                                  }
                                  <div className="img-description">
                                    {/* <div>{`image-${index}`}</div> */}
                                    <div className="delete-button" onClick={() => {
                                      const newLsit = fileList;
                                      setRemovedKey([...removedKey, newLsit.splice(index, 1)]);
                                      fileListChange(newLsit);
                                    }}>
                                      {deleteIcon}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          )
                        })
                      }
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            ) : null
            // (
            //   <div style={{ textAlign: "center", padding: "20px 0" }}>
            //     <Icon style={{ fontSize: 40, color: "#ccc" }} type="uf-upload" />
            //     <p style={{ color: "#ccc", marginTop: 10 }}>
            //     点击或拖拽图片到此处上传
            //     </p>
            //   </div>
            // )
          }
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div
          className="set_content"
          style={{ textAlign: "left", display: showSet ? "block" : "none", marginBottom: "10px" }}
        >
          <Checkbox
            style={{ lineHeight: "30px" }}
            checked={imgConfig.cranny}
            onClick={() =>
              setImgConfig({ ...imgConfig, cranny: !imgConfig.cranny })
            }
            className="test"
          >
            {localeTaget.langMap.uploadSeamlessImages || '上传无缝隙图片'}
          </Checkbox>
          <Checkbox
            style={{ lineHeight: "30px" }}
            checked={imgConfig.defaultSize}
            onClick={() =>
              setImgConfig({
                ...imgConfig,
                defaultSize: !imgConfig.defaultSize
              })
            }
            className="test"
          >
            {localeTaget.langMap.batchSizeModification || '批量修改尺寸'}
          </Checkbox>
          <InputNumber
            style={{
              width: "200px",
              boxSizing: "border-box",
              marginLeft: "20px",
              verticalAlign: "bottom"
            }}
            value={imgConfig.width}
            disabled={
              !imgConfig.defaultSize || (imgConfig.defaultSize && imgConfig.height)
            }
            onChange={(value: any) => changeSize(value, "width")}
            placeholder={`${localeTaget.langMap.width || '宽度'}`}
          />
          {/* {lock
            ? (
              <div className="lock-box">
                <Icon type="uf-dongjie"/>
              </div>
            )
            : (
              <div className="lock-box">
                <Icon type="uf-weidongjie" />
              </div>
            )} */}
          <div className="lock-box">
            <Icon type="uf-dongjie" />
          </div>
          <InputNumber
            style={{
              width: "200px",
              boxSizing: "border-box",
              marginRight: "20px",
              verticalAlign: "bottom"
            }}
            value={imgConfig.height}
            disabled={!imgConfig.defaultSize || (imgConfig.defaultSize && imgConfig.width)}
            onChange={(value: any) => changeSize(value, "height")}
            placeholder={`${localeTaget.langMap.height || '高度'}`}
          />
          <Checkbox
            style={{ lineHeight: "30px" }}
            checked={imgConfig.singleLine}
            onClick={() =>
              setImgConfig({ ...imgConfig, singleLine: !imgConfig.singleLine })
            }
            className="test"
          >
            {`${localeTaget.langMap.exclusiveRowForASingleImage || '单张图片独占一行'}`}
          </Checkbox>
        </div>
        { modalType === 'media'
          ? null
          : <Button
            type="plainText"
            style={{ float: "left", marginLeft: "-12px", color: "#0033CC" }}
            onClick={() => setShowSet(!showSet)}
          >
            {`${localeTaget.langMap.pictureSettings || '图片设置'}`}
            {showSet
              ? (
                <Icon type="uf-zhankai" style={{ marginLeft: "5px" }} />
              )
              : (
                <Icon type="uf-shouqi" style={{ marginLeft: "5px" }} />
              )}
          </Button>
        }
        <Button onClick={onClose} colors="secondary" style={{ marginRight: 8 }}>
          {`${localeTaget.langMap.cancel || '取消'}`}
        </Button>
        <Button className="coustomFocus" onClick={onSubmit} colors="primary">
          {`${localeTaget.langMap.ok || '确定'}`}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LocalModal;
